import { CartesianGrid } from 'recharts'

const BaseCartesianGrid = CartesianGrid

export default BaseCartesianGrid